"use strict";
/****
 * 参数说明：
 *
 * 获取涨跌幅 f3  涨跌额f4  换手率8  2最新价 f9最新市盈率
 *
 * 所属行业板块 f100  成交量5  成交额6
 *
 * fltt=2 返回实际浮点数，不填则返回默认放大整数
 *
 * &invt=2&secids=0.300059,0.002049,1.000001,1.600183,1.600831,116.02318,1.600202,0.002003&cb=aa
 *
 *  */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var webconfig = require('../../../config/web.js');
exports["default"] = {
    //个股行情
    getstockquto: function (secids) {
        return __awaiter(this, void 0, void 0, function () {
            var rnd, arr, back, diff, len, i, f1, f2, f3, f4, f5, f6, f8, f152, f9, f12, f14, f100, f148, f127, f198;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rnd = 'showData' + Math.floor(Math.random() * 10000000 + 1);
                        arr = {};
                        return [4 /*yield*/, $.ajax({
                                url: webconfig.getWebPath('quoteurl') + 'api/qt/ulist.np/get?cb=?&fields=f1,f2,f3,f4,f5,f6,f8,f9,f12,f14,f13,f19,f29,f100,f127,f198,f152,f148&invt=2',
                                type: 'GET',
                                jsonpCallback: rnd,
                                dataType: 'jsonp',
                                data: {
                                    ut: "c0461369b18e4d9f5bb35a99052dab5b",
                                    secids: secids
                                }
                            })];
                    case 1:
                        back = _a.sent();
                        if (back.data && back.data.diff != "") {
                            diff = back.data.diff;
                            len = back.data.diff.length;
                            for (i = 0; i < len; i++) {
                                f1 = diff[i].f1;
                                f2 = '';
                                if (diff[i].f2 == '-') {
                                    f2 = diff[i].f2;
                                }
                                else {
                                    f2 = diff[i].f2 != '' ? (diff[i].f2 / Math.pow(10, f1)).toFixed(f1) : ''; //最新价 默认根据小数位数(f1)字段进行了数值放大，建议展示(f1)位小数 
                                }
                                f3 = diff[i].f3 == '-' ? diff[i].f3 : (diff[i].f3) / 100 + '' + '%';
                                f4 = diff[i].f4;
                                f5 = diff[i].f5;
                                f6 = diff[i].f6;
                                f8 = diff[i].f8;
                                f152 = diff[i].f152;
                                f9 = '';
                                if (diff[i].f9) {
                                    f9 = diff[i].f9 == '-' ? '-' : (diff[i].f9 / Math.pow(10, f152)).toFixed(f152); //默认根据小数位数(f152)字段进行了数值放大，建议展示(f152)位小数
                                }
                                f12 = diff[i].f12;
                                f14 = diff[i].f14;
                                f100 = diff[i].f100;
                                f148 = diff[i].f148;
                                f127 = diff[i].f127;
                                f198 = diff[i].f198;
                                arr[f12] = {
                                    name: f14,
                                    zdf: f3,
                                    zde: f4,
                                    cjl: f5,
                                    cje: f6,
                                    zxj: f2,
                                    zxsyl: f9,
                                    hsl: f8,
                                    code: f12,
                                    hy: f100,
                                    state: f148
                                };
                            }
                        }
                        ;
                        return [2 /*return*/, arr];
                }
            });
        });
    },
    //行业详情
    gethyquto: function (secids) {
        return __awaiter(this, void 0, void 0, function () {
            var rnd, arr, back, diff, len, i, zdf, hysyl, code;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rnd = 'showData' + Math.floor(Math.random() * 10000000 + 1);
                        arr = {};
                        return [4 /*yield*/, $.ajax({
                                url: webconfig.getWebPath('quoteurl') + 'api/qt/ulist.np/get?cb=?&fields=f1,f2,f3,f4,f5,f8,f12,f14,f114,f152&invt=2',
                                type: 'GET',
                                jsonpCallback: rnd,
                                dataType: 'jsonp',
                                data: {
                                    ut: "c0461369b18e4d9f5bb35a99052dab5b",
                                    secids: secids
                                }
                            })];
                    case 1:
                        back = _a.sent();
                        if (back.data && back.data.diff != "") {
                            diff = back.data.diff;
                            len = back.data.diff.length;
                            for (i = 0; i < len; i++) {
                                zdf = diff[i].f3;
                                if (zdf == '-' || zdf === '') {
                                    // zdf = 0
                                }
                                else {
                                    zdf = Number(zdf / 100).toFixed(2);
                                    zdf = zdf + '' + '%';
                                }
                                hysyl = diff[i].f114;
                                code = (diff[i].f12).substring(2);
                                if (code.indexOf(0) == 0) {
                                    code = code.substring(1);
                                }
                                ;
                                arr[code] = {
                                    zdf: zdf,
                                    hysyl: hysyl + ''
                                };
                            }
                        }
                        ;
                        return [2 /*return*/, arr];
                }
            });
        });
    },
    //根据行业板块获取行情信息:行业正文里的领涨个股、资金流入
    //po列表页面的顺序，正序填0，倒序填1，默认为1。
    //主力股净流入是f62，单位是元
    getBKqute: function (params) {
        var _this = this;
        var sortFiles = params.fid;
        // let url = webconfig.getWebPath('quoteurl') + 'api/qt/clist/get?pn=1&pz=15&po=1&np=1&fltt=2&invt=2&fid=f112&fields=f12,f13,f14,f112'
        var url = webconfig.getWebPath('quoteurl') + 'api/qt/clist/get?pn=1&pz=4&po=1&np=1&fltt=2&invt=2&ut=8dec03ba335b81bf4ebdf7b29ec27d15&cb=?';
        return $.ajax({
            url: url,
            type: 'GET',
            dataType: 'jsonp',
            data: params
        }).then(function (res) {
            var diff = res.data.diff;
            var data = {};
            data['data'] = [];
            for (var i = 0; i < diff.length; i++) {
                var element = diff[i];
                var value = element[sortFiles];
                var f59 = diff[i].f59;
                if (sortFiles == 'f62') { //这个主力净流入是f62，单位是元
                    // value = (value / Math.pow(10, f59)).toFixed(f59)
                    value = value != '-' ? (value / 10000).toFixed(2) : value; //返回的是万元
                }
                var obj = {
                    name: element['f14'],
                    code: element['f12'],
                    market: element['f13'],
                    value: value
                };
                data['data'].push(obj);
            }
            ;
            return data;
        });
    }
};
